import { useCallback } from "react";
import { useAuth } from "../contexts/AuthContext";

export const ROLE_LABEL = {
  owner: "Chủ sở hữu",
  reviewer: "Biên tập viên duyệt",
  editor: "Biên tập viên",
  viewer: "Chỉ xem",
};

/**
 * Quyền của admin đang đăng nhập (khớp utils/permissions.js ở backend).
 * Phiên cũ chưa có danh sách quyền → coi là có quyền để không khoá nhầm giao diện;
 * backend vẫn kiểm tra thật và trả 403 nếu không đủ quyền.
 */
export function usePermission() {
  const { user } = useAuth();
  const known = Array.isArray(user?.permissions);
  const can = useCallback((perm) => (known ? user.permissions.includes(perm) : user?.role === "admin"), [known, user]);
  return { can, role: user?.adminRole || "owner", roleLabel: ROLE_LABEL[user?.adminRole || "owner"] };
}
